import styled from '../../../styled';
const ItemRowContainer = styled.div `
  display: flex;
  height: 3.75rem;
  cursor: pointer;
  user-select: none;

  &:not(:last-child) {
    border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
  }

  .checkboxColumn {
    display: flex;
    align-items: center;
    padding: 0.5rem;

    // fix Checkbox style
    label {
      margin-bottom: 0;
    }
  }

  &:hover {
    background: ${({ theme }) => theme.colors.PRIMARY_100};
  }

  ${({ isSelected, theme }) => isSelected && `background: ${theme.colors.PRIMARY_200};`}

  ${({ isDisabled }) => isDisabled &&
    `
    cursor: not-allowed;

    > div {
      opacity: 0.2;
    }
  `}
`;
export default ItemRowContainer;
//# sourceMappingURL=ItemRowContainer.js.map